import { t as e } from "../i18n.mjs";
//#region src/utils/aspect-ratio.ts
async function t(e) {
	return new Promise((t, n) => {
		let r = new Image();
		r.src = e, r.crossOrigin = "Anonymous", r.onload = () => {
			let e = r.width / r.height;
			t([r, e]);
		}, r.onerror = (e) => {
			n(/* @__PURE__ */ Error("Failed to load image"));
		};
	});
}
function n(e, t, n = .02) {
	return Math.abs(e - t) < n;
}
function r(e, t = .02) {
	return [
		{
			label: "(1:1)",
			value: 1
		},
		{
			label: "(16:9)",
			value: 16 / 9
		},
		{
			label: "(21:9)",
			value: 21 / 9
		},
		{
			label: "(4:3)",
			value: 4 / 3
		},
		{
			label: "(1.43:1)",
			value: 1.43
		},
		{
			label: "(32:9)",
			value: 32 / 9
		},
		{
			label: "(1.41:1)",
			value: 1.41
		},
		{
			label: "(9:16)",
			value: 9 / 16
		},
		{
			label: "(19.5:9)",
			value: 19.5 / 9
		},
		{
			label: "(12:7)",
			value: 12 / 7
		}
	].find((n) => Math.abs(e - n.value) < t)?.label;
}
function i(t, n = .02) {
	let i = r(t, n), a = e("file_manager.image_cropper.aspect_ratio.need_to_crop");
	return i && (a += ` ${i}`), a;
}
function a(e, t) {
	if (!t || isNaN(t)) return e;
	let n = r(t);
	if (!n) return e;
	let i = n.replace(/[\s:]+/g, "_"), a = e.name.split(".").pop(), o = `${e.name.replace(/\.[^.]+$/, "")}_${i}.${a}`;
	return new File([e], o, {
		type: e.type,
		lastModified: e.lastModified
	});
}
//#endregion
export { a as appendAspectRatioToFileName, n as areAspectRatiosEqual, r as getAspectRatioLabel, i as getAspectRatioNote, t as getImageAspectRatio };
